
import { useState } from 'react';

export default function Menu() {
  const [selectedCategory, setSelectedCategory] = useState('combos');

  const categories = [
    { id: 'combos', label: 'Combos', icon: 'ri-shopping-basket-fill' },
    { id: 'buckets', label: 'Buckets', icon: 'ri-inbox-fill' },
    { id: 'sides', label: 'Acompanhamentos', icon: 'ri-cake-3-fill' },
    { id: 'drinks', label: 'Bebidas', icon: 'ri-cup-fill' }
  ];

  const menuItems = {
    combos: [
      {
        name: 'Combo Individual',
        description: '3 pedaços de frango + batata frita + refrigerante',
        price: 'R$ 29,90',
        image: 'https://public.readdy.ai/ai/img_res/1acf93c19e3e334191a54e0479deb556.jpg'
      },
      {
        name: 'Combo Família',
        description: '12 pedaços de frango + 2 batatas grandes + 2L refrigerante',
        price: 'R$ 89,90',
        image: 'https://readdy.ai/api/search-image?query=large%20family%20fried%20chicken%20meal%20with%20twelve%20golden%20crispy%20chicken%20pieces%2C%20large%20fries%20portions%20and%20big%20soda%20bottle%20on%20red%20background%2C%20abundant%20food%20photography%2C%20sharing%20meal%20presentation&width=400&height=400&seq=menu-combo-002&orientation=squarish'
      },
      {
        name: 'Combo Casal',
        description: '6 pedaços de frango + batata grande + 2 refrigerantes',
        price: 'R$ 54,90',
        image: 'https://readdy.ai/api/search-image?query=couple%20fried%20chicken%20combo%20with%20six%20crispy%20golden%20pieces%2C%20large%20fries%20and%20two%20soda%20cans%20on%20red%20background%2C%20romantic%20meal%20presentation%2C%20professional%20food%20photography&width=400&height=400&seq=menu-combo-003&orientation=squarish'
      },
      {
        name: 'Combo Kids',
        description: '2 pedaços de frango + batata pequena + suco',
        price: 'R$ 19,90',
        image: 'https://readdy.ai/api/search-image?query=kids%20fried%20chicken%20meal%20with%20two%20small%20crispy%20chicken%20pieces%2C%20small%20fries%20and%20juice%20box%20on%20red%20background%2C%20child-friendly%20presentation%2C%20colorful%20and%20fun%20food%20photography&width=400&height=400&seq=menu-combo-004&orientation=squarish'
      }
    ],
    buckets: [
      {
        name: 'Bucket 6 Pedaços',
        description: 'Frango crocante em bucket exclusivo',
        price: 'R$ 39,90',
        image: 'https://readdy.ai/api/search-image?query=red%20bucket%20filled%20with%20six%20pieces%20of%20crispy%20golden%20fried%20chicken%2C%20branded%20bucket%20container%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20appetizing%20presentation&width=400&height=400&seq=menu-bucket-001&orientation=squarish'
      },
      {
        name: 'Bucket 12 Pedaços',
        description: 'Perfeito para compartilhar',
        price: 'R$ 69,90',
        image: 'https://readdy.ai/api/search-image?query=large%20red%20bucket%20overflowing%20with%20twelve%20pieces%20of%20crispy%20golden%20fried%20chicken%2C%20family%20size%20bucket%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20generous%20portion&width=400&height=400&seq=menu-bucket-002&orientation=squarish'
      },
      {
        name: 'Bucket 20 Pedaços',
        description: 'Para festas e eventos',
        price: 'R$ 109,90',
        image: 'https://readdy.ai/api/search-image?query=extra%20large%20red%20bucket%20with%20twenty%20pieces%20of%20crispy%20golden%20fried%20chicken%2C%20party%20size%20bucket%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20abundant%20feast%20presentation&width=400&height=400&seq=menu-bucket-003&orientation=squarish'
      },
      {
        name: 'Bucket Mix',
        description: '10 pedaços variados + 5 tiras de frango',
        price: 'R$ 79,90',
        image: 'https://readdy.ai/api/search-image?query=red%20bucket%20with%20mixed%20fried%20chicken%20pieces%20and%20chicken%20strips%2C%20variety%20bucket%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20diverse%20chicken%20selection&width=400&height=400&seq=menu-bucket-004&orientation=squarish'
      }
    ],
    sides: [
      {
        name: 'Batata Frita Grande',
        description: 'Crocante e sequinha',
        price: 'R$ 12,90',
        image: 'https://readdy.ai/api/search-image?query=large%20portion%20of%20crispy%20golden%20french%20fries%20in%20red%20container%2C%20perfectly%20cooked%20fries%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20appetizing%20side%20dish&width=400&height=400&seq=menu-side-001&orientation=squarish'
      },
      {
        name: 'Onion Rings',
        description: '10 unidades crocantes',
        price: 'R$ 14,90',
        image: 'https://readdy.ai/api/search-image?query=stack%20of%20ten%20crispy%20golden%20onion%20rings%20in%20red%20container%2C%20perfectly%20breaded%20rings%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20crunchy%20appetizer&width=400&height=400&seq=menu-side-002&orientation=squarish'
      },
      {
        name: 'Nuggets',
        description: '12 unidades douradas',
        price: 'R$ 16,90',
        image: 'https://readdy.ai/api/search-image?query=twelve%20golden%20crispy%20chicken%20nuggets%20in%20red%20container%2C%20perfectly%20cooked%20nuggets%2C%20professional%20food%20photography%20on%20solid%20red%20background%2C%20kid-friendly%20snack&width=400&height=400&seq=menu-side-003&orientation=squarish'
      },
      {
        name: 'Molhos Especiais',
        description: 'Barbecue, mostarda e mel, picante',
        price: 'R$ 3,90',
        image: 'https://readdy.ai/api/search-image?query=three%20small%20containers%20with%20different%20colored%20sauces%20barbecue%20honey%20mustard%20and%20spicy%20on%20red%20background%2C%20sauce%20variety%2C%20professional%20food%20photography%2C%20condiment%20presentation&width=400&height=400&seq=menu-side-004&orientation=squarish'
      }
    ],
    drinks: [
      {
        name: 'Refrigerante Lata',
        description: 'Coca-Cola, Guaraná, Fanta',
        price: 'R$ 5,90',
        image: 'https://readdy.ai/api/search-image?query=cold%20soda%20can%20with%20water%20droplets%20on%20red%20background%2C%20refreshing%20beverage%2C%20professional%20product%20photography%2C%20chilled%20drink%20presentation&width=400&height=400&seq=menu-drink-001&orientation=squarish'
      },
      {
        name: 'Refrigerante 2L',
        description: 'Várias opções disponíveis',
        price: 'R$ 10,90',
        image: 'https://readdy.ai/api/search-image?query=large%20two%20liter%20soda%20bottle%20with%20condensation%20on%20red%20background%2C%20family%20size%20beverage%2C%20professional%20product%20photography%2C%20cold%20drink&width=400&height=400&seq=menu-drink-002&orientation=squarish'
      },
      {
        name: 'Suco Natural',
        description: 'Laranja, limão ou maracujá - 500ml',
        price: 'R$ 8,90',
        image: 'https://readdy.ai/api/search-image?query=fresh%20natural%20juice%20in%20clear%20bottle%20with%20fruit%20slices%20on%20red%20background%2C%20healthy%20beverage%2C%20professional%20product%20photography%2C%20refreshing%20drink&width=400&height=400&seq=menu-drink-003&orientation=squarish'
      },
      {
        name: 'Água Mineral',
        description: 'Com ou sem gás - 500ml',
        price: 'R$ 4,90',
        image: 'https://readdy.ai/api/search-image?query=mineral%20water%20bottle%20with%20water%20droplets%20on%20red%20background%2C%20pure%20hydration%2C%20professional%20product%20photography%2C%20clean%20beverage%20presentation&width=400&height=400&seq=menu-drink-004&orientation=squarish'
      }
    ]
  };

  const whatsappNumber = '5519971394274';

  return (
    <section id="menu" className="py-16 md:py-24 bg-red-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-yellow-400 mb-4">
            NOSSO CARDÁPIO
          </h2>
          <div className="w-24 md:w-32 h-2 bg-yellow-400 mx-auto rounded-full"></div>
          <p className="text-white text-base md:text-xl mt-4 md:mt-6">Escolha seu favorito e faça seu pedido!</p>
        </div>

        {/* Categorias */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8 md:mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-xs md:text-sm transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer ${
                selectedCategory === category.id
                  ? 'bg-yellow-400 text-black scale-110'
                  : 'bg-white text-black hover:bg-yellow-100'
              }`}
            >
              <i className={`${category.icon} text-base md:text-lg`}></i>
              {category.label}
            </button>
          ))}
        </div>

        {/* Grid de itens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {menuItems[selectedCategory as keyof typeof menuItems].map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-300 hover:shadow-yellow-400/50"
            >
              <div className="relative w-full h-48 sm:h-56 md:h-64">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-yellow-400 text-black px-3 py-1 rounded-full font-black text-sm md:text-lg">
                  {item.price}
                </div>
              </div>
              <div className="p-4 md:p-6">
                <h3 className="text-base md:text-xl font-black text-black mb-1 md:mb-2">{item.name}</h3>
                <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4">{item.description}</p>
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`Olá! Gostaria de pedir: ${item.name} (${item.price}) 🍗`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-red-600 text-white py-2 md:py-3 rounded-full font-bold hover:bg-red-700 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap text-sm md:text-base cursor-pointer"
                >
                  <i className="ri-whatsapp-fill"></i>
                  Pedir agora
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
